/* VEJI cart UI — delegates all cart mutations to VejiCartOffer. */
(function () {
  'use strict';

  var drawerRootSelector = '[data-veji-cart-root]';
  var pageRootSelector = '[data-veji-cart-page]';
  var lastFocus = null;
  var uiBusy = false;
  var renderConfirmed = true;
  var client = null;
  var addRecoveryError = null;

  function drawerRoot() { return document.querySelector(drawerRootSelector); }
  function pageRoot() { return document.querySelector(pageRootSelector); }
  function cartRoot() { return drawerRoot() || pageRoot(); }
  function sectionId(node, fallback) { return (node && node.getAttribute('data-veji-cart-section')) || fallback; }
  function drawerSectionId() { return sectionId(drawerRoot(), 'veji-cart-drawer'); }
  function pageSectionId() { return sectionId(pageRoot(), null); }

  function approvedRuntime() {
    var theme = window.Shopify && window.Shopify.theme;
    var host = window.location && String(window.location.hostname || '').toLowerCase();
    if (!theme) return false;
    var production = [193625784695, 193555956087, 193942684023, 194150662519].indexOf(Number(theme.id)) !== -1 && (theme.role === 'main' || theme.role === 'unpublished') &&
      (host === 'vejinutrition.fr' || host === 'ty8jpy-u1.myshopify.com');
    var development = Number(theme.id) === 193674379639 && theme.role === 'development' &&
      (host === '127.0.0.1' || host === 'localhost');
    return production || development;
  }

  function offerClient() {
    if (!approvedRuntime()) throw new Error('Le panier dynamique est limité au runtime autorisé.');
    if (client) return client;
    if (!window.VejiCartOffer || typeof window.VejiCartOffer.createClient !== 'function') {
      throw new Error('Le moteur panier est indisponible.');
    }
    var storefrontRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    client = window.VejiCartOffer.createClient({ fetch: (window.fetch || fetch).bind(window), root: typeof storefrontRoot === 'string' ? storefrontRoot : '/' });
    if (!client || typeof client.add !== 'function' || typeof client.change !== 'function' || typeof client.reconcile !== 'function') {
      throw new Error('Le moteur panier est invalide.');
    }
    return client;
  }

  function isBusy() {
    return uiBusy || !!(client && typeof client.busy === 'function' && client.busy());
  }

  function status(message) {
    Array.prototype.forEach.call(document.querySelectorAll('[data-veji-cart-status]'), function (node) {
      node.textContent = message || '';
      node.classList.toggle('visually-hidden', !message);
    });
  }

  function setBusy(active) {
    var r = cartRoot();
    if (r) r.setAttribute('aria-busy', active ? 'true' : 'false');
    var page = pageRoot();
    if (page) page.setAttribute('aria-busy', active ? 'true' : 'false');
    Array.prototype.forEach.call(document.querySelectorAll('[data-veji-cart-change], [data-veji-cart-remove], [data-veji-cart-add], [data-veji-cart-cross-sell-add], [data-veji-purchase-toggle], [data-veji-purchase-cadence], [data-veji-cart-checkout]'), function (control) {
      var purchase = control.getAttribute('data-veji-purchase-toggle') !== null || control.getAttribute('data-veji-purchase-cadence') !== null;
      var disabled = active || !!addRecoveryError || !renderConfirmed || (purchase && !control.vejiPurchaseReady) || (control.getAttribute('data-veji-cart-cross-sell-add') !== null && !control.vejiComplementOffer);
      control.disabled = disabled;
      control.setAttribute('aria-disabled', disabled ? 'true' : 'false');
    });
    window.dispatchEvent(new window.CustomEvent('veji-cart:busy', { detail: { locked: active || !!addRecoveryError || !renderConfirmed } }));
  }

  function errorMessage(error) {
    return error && error.message ? error.message : 'Le panier n’a pas pu être mis à jour. Réessayez.';
  }

  function rejectBusy() {
    var error = new Error('Mise à jour en cours.');
    status(error.message);
    return Promise.reject(error);
  }

  function mutation(work, recovery) {
    if (isBusy()) return rejectBusy();
    if (addRecoveryError && !recovery) return Promise.reject(addRecoveryError);
    var wasConfirmed = renderConfirmed;
    uiBusy = true;
    renderConfirmed = false;
    setBusy(true);
    status('Mise à jour du panier…');
    return Promise.resolve()
      .then(work)
      .then(function (result) { renderConfirmed = true; return result; })
      .catch(function (error) {
        if (error && error.vejiCartAmbiguous) {
          addRecoveryError = error;
          if (!error.vejiCartAdded) error.message = 'Mise à jour non confirmée. Fermez puis rouvrez le panier pour vérifier, sans répéter votre action.';
        } else if (!addRecoveryError) {
          if (client && typeof client.verify === 'function') {
            return client.verify().then(refresh).then(function () { renderConfirmed = true; throw error; }, function () { throw error; });
          }
          renderConfirmed = wasConfirmed;
        }
        throw error;
      })
      .finally(function () {
        uiBusy = false;
        setBusy(false);
      });
  }

  function sectionURL(ids) {
    var location = window.location;
    var separator = location.search ? '&' : '?';
    return location.pathname + (location.search || '') + separator + 'sections=' + encodeURIComponent(ids.join(',')) + '&_veji=' + Date.now();
  }

  function focusedToken() {
    var active = document.activeElement;
    return active && active.getAttribute && active.getAttribute('data-veji-cart-focus');
  }

  function restoreFocus(token) {
    if (!token) return;
    var nodes = document.querySelectorAll('[data-veji-cart-focus]');
    for (var i = 0; i < nodes.length; i += 1) {
      if (nodes[i].getAttribute('data-veji-cart-focus') === token && nodes[i].focus) {
        nodes[i].focus();
        return;
      }
    }
  }

  // Shipping presentation only: never authorizes or changes a cart mutation.
  function captureShipping(root) {
    try {
      var gauge = root && root.querySelector('[data-veji-shipping]');
      if (!gauge) return { total: 0, progress: 0, mode: null };
      var fill = gauge.querySelector('.veji-ship-fill');
      var track = gauge.querySelector('.veji-ship-track');
      var width = track.getBoundingClientRect().width;
      var progress = width ? fill.getBoundingClientRect().width / width * 100 : Number(gauge.getAttribute('data-progress'));
      var state = { total: Number(gauge.getAttribute('data-total')), progress: progress, mode: gauge.getAttribute('data-mode') };
      // Cancel only this detached presentation, after reading the visible position.
      gauge.querySelectorAll('*').forEach(function (node) {
        if (node.getAnimations) node.getAnimations().forEach(function (animation) { animation.cancel(); });
      });
      return state;
    } catch (error) { return null; }
  }

  function animateShipping(root, previous) {
    try {
      var gauge = root && root.querySelector('[data-veji-shipping]');
      if (!gauge || !previous || !window.matchMedia || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var total = Number(gauge.getAttribute('data-total'));
      var progress = Number(gauge.getAttribute('data-progress'));
      var mode = gauge.getAttribute('data-mode');
      var fill = gauge.querySelector('.veji-ship-fill');
      if (!fill.animate || !Number.isFinite(previous.progress) || !Number.isFinite(progress)) return;
      if (total === previous.total && mode === previous.mode) return;
      if (progress !== previous.progress) {
        fill.animate([{ width: previous.progress + '%' }, { width: progress + '%' }], { duration: 720, easing: 'cubic-bezier(.22,1,.36,1)' });
      }
      if (previous.mode && mode !== previous.mode) return;
      gauge.querySelectorAll('.veji-ship-stop').forEach(function (stop) {
        var threshold = Number(stop.getAttribute('data-threshold'));
        if (previous.total >= threshold || total < threshold) return;
        var circle = stop.querySelector('.veji-ship-circle');
        var reward = stop.querySelector('.veji-ship-reward');
        circle.animate([
          { transform: 'scale(1)', backgroundColor: 'var(--cd-bg)', borderColor: '#D7DDD5', color: '#8A958D' },
          { transform: 'scale(1.12)', offset: .4 },
          { transform: 'scale(.98)', offset: .75 },
          { transform: 'scale(1)' }
        ], { duration: 550, delay: 260, fill: 'backwards', easing: 'cubic-bezier(.22,1,.36,1)' });
        reward.animate([{ opacity: 0, transform: 'translateY(4px)' }, { opacity: 1, transform: 'translateY(0)' }],
          { duration: 350, delay: 260, fill: 'backwards', easing: 'cubic-bezier(.22,1,.36,1)' });
        if (threshold === 4800) {
          gauge.querySelector('.veji-ship-shine').animate([
            { transform: 'translateX(-110%)', opacity: 0 },
            { opacity: 1, offset: .15 },
            { transform: 'translateX(110%)', opacity: 0 }
          ], { duration: 700, delay: 260, easing: 'ease-out' });
        }
      });
    } catch (error) { /* Cosmetic failure must never block cart confirmation. */ }
  }

  function replaceDrawer(html) {
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var freshRoot = parsed.querySelector(drawerRootSelector);
    var freshInner = parsed.querySelector('[data-veji-cart-inner]');
    var currentRoot = drawerRoot();
    var currentInner = currentRoot && currentRoot.querySelector('[data-veji-cart-inner]');
    if (!freshRoot || !freshInner || !currentRoot || !currentInner) throw new Error('Section panier invalide.');
    var token = focusedToken();
    var shipping = captureShipping(currentInner);
    currentInner.innerHTML = freshInner.innerHTML;
    animateShipping(currentInner, shipping);
    currentRoot.setAttribute('data-cart-count', freshRoot.getAttribute('data-cart-count') || '0');
    updateBadge(parseInt(freshRoot.getAttribute('data-cart-count'), 10) || 0);
    restoreFocus(token);
    initDynamic();
  }

  function replacePage(html) {
    var current = pageRoot();
    if (!current) return;
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var fresh = parsed.querySelector(pageRootSelector);
    if (!fresh) throw new Error('Section page panier invalide.');
    var token = focusedToken();
    var shipping = captureShipping(current);
    current.innerHTML = fresh.innerHTML;
    animateShipping(current, shipping);
    restoreFocus(token);
    initDynamic();
  }

  function confirmSection(html, cart) {
    if (!cart || !Array.isArray(cart.items)) return;
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var lines = Array.prototype.slice.call(parsed.querySelectorAll('[data-veji-cart-line]'));
    if (lines.length !== cart.items.length) throw new Error('Rendu panier périmé.');
    cart.items.forEach(function (item) {
      var matches = lines.filter(function (node) { return node.getAttribute('data-key') === item.key; });
      var id = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan && item.selling_plan_allocation.selling_plan.id;
      if (matches.length !== 1 || Number(matches[0].getAttribute('data-quantity')) !== item.quantity ||
        Number(matches[0].getAttribute('data-final-line-price')) !== item.final_line_price ||
        Number(matches[0].getAttribute('data-cart-total')) !== cart.total_price || matches[0].getAttribute('data-cart-currency') !== cart.currency ||
        (matches[0].getAttribute('data-selling-plan') || '') !== (id ? String(id) : '')) throw new Error('Rendu panier périmé.');
    });
  }

  function refresh(cart) {
    var ids = [drawerSectionId()];
    var pageId = pageSectionId();
    if (pageId && ids.indexOf(pageId) === -1) ids.push(pageId);
    return (window.fetch || fetch)(sectionURL(ids), { credentials: 'same-origin', cache: 'no-store', headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (response) {
        if (!response || response.ok === false) throw new Error('Le panier n’a pas pu être actualisé.');
        return response.json();
      })
      .then(function (sections) {
        if (!sections || typeof sections[drawerSectionId()] !== 'string') throw new Error('Section panier absente.');
        confirmSection(sections[drawerSectionId()], cart);
        if (pageId) {
          if (typeof sections[pageId] !== 'string') throw new Error('Section page panier absente.');
          confirmSection(sections[pageId], cart);
        }
        replaceDrawer(sections[drawerSectionId()]);
        if (pageId) replacePage(sections[pageId]);
        setBusy(true);
        return prepareOffers().then(function () { return sections; });
      });
  }

  function updateBadge(count) {
    var badge = document.querySelector('[data-veji-cart-badge]');
    if (!badge) return;
    badge.textContent = count;
    badge.classList.toggle('is-visible', count > 0);
  }

  function openDrawer() {
    var root = drawerRoot();
    if (!root || root.classList.contains('is-open')) return;
    lastFocus = document.activeElement;
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.body.classList.add('veji-cart-open');
    document.addEventListener('keydown', trapFocus, true);
    var closeButton = root.querySelector('[data-veji-cart-close]');
    if (closeButton && closeButton.focus) closeButton.focus();
  }

  function closeDrawer() {
    var root = drawerRoot();
    if (!root || !root.classList.contains('is-open')) return;
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('veji-cart-open');
    document.removeEventListener('keydown', trapFocus, true);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  var focusableSelector = 'a[href], summary, button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  function trapFocus(event) {
    if (event.key !== 'Tab') return;
    var root = drawerRoot();
    if (!root || !root.classList.contains('is-open')) return;
    var nodes = Array.prototype.filter.call(root.querySelectorAll(focusableSelector), function (node) { return node.offsetParent !== null || node === document.activeElement; });
    if (!nodes.length) { event.preventDefault(); return; }
    if (!root.contains(document.activeElement)) { event.preventDefault(); nodes[0].focus(); return; }
    if (event.shiftKey && document.activeElement === nodes[0]) { event.preventDefault(); nodes[nodes.length - 1].focus(); }
    if (!event.shiftKey && document.activeElement === nodes[nodes.length - 1]) { event.preventDefault(); nodes[0].focus(); }
  }

  function addWith(work) {
    if (addRecoveryError) return Promise.reject(addRecoveryError);
    return mutation(function () {
      var added = false;
      return work(offerClient())
        .then(function (cart) {
          added = true;
          if (cart && Number.isSafeInteger(cart.item_count)) updateBadge(cart.item_count);
          return refresh(cart);
        })
        .then(function () { openDrawer(); status(''); })
        .catch(function (error) {
          if (!added && (!error || error.vejiCartAmbiguous !== true)) throw error;
          error.vejiCartAmbiguous = true;
          if (added) error.vejiCartAdded = true;
          addRecoveryError = error;
          error.message = error.vejiCartAdded === true
            ? 'Ajout enregistré. Vérifiez votre panier avant tout nouvel ajout.'
            : 'Ajout non confirmé. Vérifiez votre panier avant de réessayer.';
          // Recover the actual display with a read only; never replay the add.
          return refresh().then(function () {
            openDrawer(); status(error.message); throw error;
          }, function () { status(error.message); throw error; });
        });
    });
  }

  function addItems(items) {
    return addWith(function (engine) { return engine.add(items); });
  }

  function addComparisonComplement(productId, variantId) {
    return addWith(function (engine) {
      return engine.verify().then(function (cart) {
        if (cart.items.some(function (item) { return Number(item.product_id) === productId; })) return cart;
        if (!cart.items.length) return engine.add([{ id: variantId, quantity: 1 }]);
        return engine.previewComplement(productId).then(function (offer) {
          if (!offer || offer.variantId !== variantId) throw new Error('Vérifiez votre panier pour compléter votre routine.');
          return engine.addComplement(offer);
        });
      });
    });
  }

  function complementOffer(button) {
    if (!button.vejiComplementOffer) throw new Error('Offre complémentaire indisponible.');
    return button.vejiComplementOffer;
  }

  function prepareComplements(previews) {
    var cards = Array.prototype.slice.call(document.querySelectorAll('[data-veji-cart-cross-sell]'));
    var chain = Promise.resolve();
    var quotes = {};
    cards.forEach(function (card) {
      var button = card.querySelector('[data-veji-cart-cross-sell-add]');
      card.hidden = true;
      if (!approvedRuntime() || !button) return;
      button.disabled = true;
      button.vejiComplementOffer = null;
      var id = Number(button.getAttribute('data-product-id'));
      chain = chain.then(function () {
        if (!quotes[id]) quotes[id] = previews ? Promise.resolve(previews.complements[id]) : offerClient().previewComplement(id);
        return quotes[id].then(function (offer) {
          if (!offer) return;
          function money(cents) { return (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: offer.currency }); }
          card.querySelector('[data-veji-cross-sell-price]').textContent = money(offer.price);
          var reference = card.querySelector('[data-veji-cross-sell-reference]');
          reference.textContent = money(offer.referencePrice);
          reference.hidden = offer.price >= offer.referencePrice;
          card.querySelector('[data-veji-cross-sell-mode]').textContent = offer.sellingPlan ? 'Abonnement · tous les ' + offer.cadence + ' mois' : 'Achat unique';
          var shipping = card.querySelector('[data-veji-cross-sell-shipping]');
          if (shipping) shipping.hidden = !!offer.sellingPlan;
          button.vejiComplementOffer = offer;
          card.hidden = false;
        }, function () { card.hidden = true; });
      });
    });
    return chain;
  }

  function resetComplement() {
    document.querySelectorAll('[data-veji-cross-sell-error]').forEach(function (note) { note.hidden = true; note.textContent = ''; });
  }

  function reportComplement(error) {
    var message = errorMessage(error);
    document.querySelectorAll('[data-veji-cross-sell-error]').forEach(function (note) { note.textContent = message; note.hidden = false; });
    status(message);
  }

  function addComplement(button) {
    if (isBusy()) return rejectBusy();
    if (!renderConfirmed) return Promise.reject(new Error('Panier non confirmé.'));
    var offer = complementOffer(button);
    resetComplement();
    return mutation(function () {
      var engine = offerClient();
      if (typeof engine.addComplement !== 'function') throw new Error('Le moteur panier est invalide.');
      var added = false;
      return engine.addComplement(offer).then(function (cart) { added = true; return refresh(cart); }).then(function () { openDrawer(); status(''); }).catch(function (error) {
        if (added) { error.vejiCartAdded = true; error.vejiCartAmbiguous = true; }
        if (error.vejiCartAdded) error.message = 'Ajout enregistré. Fermez puis rouvrez le panier pour actualiser son affichage.';
        throw error;
      });
    });
  }

  function purchaseMatches(offer, row) {
    return offer.key === row.getAttribute('data-key') && offer.quantity === Number(row.getAttribute('data-quantity')) &&
      String(offer.currentPlanId || '') === row.getAttribute('data-selling-plan') && offer.currentLinePrice === Number(row.getAttribute('data-final-line-price')) &&
      offer.currency === row.getAttribute('data-cart-currency') && offer.currentTotal === Number(row.getAttribute('data-cart-total'));
  }

  function preparePurchases(previews) {
    var chain = Promise.resolve(), offers = {};
    document.querySelectorAll('[data-veji-purchase]').forEach(function (block) {
      var row = block.closest('[data-veji-cart-line]'), key = row.getAttribute('data-key');
      var cadence = Number(block.getAttribute('data-cadence'));
      chain = chain.then(function () {
        if (!offers[key]) offers[key] = previews ? Promise.resolve(previews.purchases[key]) : offerClient().previewPurchase(key, cadence);
        return offers[key].then(function (offer) {
          if (!purchaseMatches(offer, row)) throw new Error('Offre abonnement périmée.');
          block.querySelectorAll('[data-veji-purchase-toggle], [data-veji-purchase-cadence]').forEach(function (control) { control.vejiPurchaseReady = true; });
        }).catch(function () {
          // Existing subscriptions remain readable; an unqualified upsell stays absent.
          if (block.getAttribute('data-subscribed') !== 'true') block.hidden = true;
        });
      });
    });
    return chain;
  }

  function prepareOffers() {
    var engine = offerClient();
    // Preserve compatibility while the two assets arrive independently from CDN.
    if (typeof engine.previewOffers !== 'function') return preparePurchases().then(function () { return prepareComplements(); });
    var purchases = [], complements = [];
    document.querySelectorAll('[data-veji-purchase]').forEach(function (block) {
      var key = block.closest('[data-veji-cart-line]').getAttribute('data-key');
      if (!purchases.some(function (request) { return request.key === key; })) purchases.push({ key: key, cadence: Number(block.getAttribute('data-cadence')) });
    });
    document.querySelectorAll('[data-veji-cart-cross-sell-add]').forEach(function (button) {
      var id = Number(button.getAttribute('data-product-id'));
      if (complements.indexOf(id) === -1) complements.push(id);
    });
    if (!purchases.length && !complements.length) return Promise.resolve();
    return engine.previewOffers(purchases, complements).catch(function () {
      // As before, unavailable optional quotes stay disabled/hidden.
      return { purchases: Object.create(null), complements: Object.create(null) };
    }).then(function (previews) { return preparePurchases(previews).then(function () { return prepareComplements(previews); }); });
  }

  function changePurchase(control, cadence) {
    var block = control.closest('[data-veji-purchase]'), row = block.closest('[data-veji-cart-line]');
    var key = row.getAttribute('data-key'), focusToken = null;
    var kind = control.hasAttribute('data-veji-purchase-toggle') ? 'purchase' : 'cadence';
    var surface = row.closest(pageRootSelector) ? 'page' : 'drawer';
    // The current selection remains authoritative until Shopify and both sections agree.
    if (kind === 'purchase') control.checked = block.getAttribute('data-subscribed') === 'true';
    else control.value = block.getAttribute('data-cadence');
    if (!control.vejiPurchaseReady || !renderConfirmed) return Promise.reject(new Error('Offre abonnement indisponible.'));
    return mutation(function () {
      var engine = offerClient(), changed = false;
      return engine.previewPurchase(key, cadence).then(function (offer) {
        if (!purchaseMatches(offer, row)) throw new Error('Panier actualisé. Vérifiez votre choix puis réessayez.');
        return engine.changePurchase(key, cadence, offer).then(function (cart) {
          changed = true;
          var target = cart.items.filter(function (item) {
            var props = {}; Object.keys(item.properties || {}).sort().forEach(function (key) { props[key] = item.properties[key]; });
            var plan = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan;
            return Number(item.variant_id) === Number(offer.variantId) && JSON.stringify(props) === offer.properties &&
              (cadence ? plan && Number(String(plan.options[0].value).split(' ')[0]) === cadence : !item.selling_plan_allocation);
          })[0];
          if (target) focusToken = surface + '-' + kind + '-' + target.key;
          return refresh(cart);
        });
      }).then(function () { status(''); }).catch(function (error) { if (changed) error.vejiCartAmbiguous = true; throw error; });
    }).then(function () { restoreFocus(focusToken); });
  }

  function closePurchaseInfo(target, focus) {
    var closed = false;
    document.querySelectorAll('.veji-cd-purchase-info[open]').forEach(function (details) {
      if (target && details.contains(target)) return;
      details.open = false;
      if (focus) details.querySelector('summary').focus();
      closed = true;
    });
    return closed;
  }

  function changeLine(key, quantity) {
    if (!key || isNaN(quantity) || quantity < 0) return Promise.reject(new Error('Quantité invalide.'));
    return mutation(function () {
      var changed = false;
      return offerClient().change(key, quantity)
        .then(function (cart) { changed = true; return refresh(cart); })
        .then(function () { status(''); })
        .catch(function (error) { if (changed) error.vejiCartAmbiguous = true; throw error; });
    });
  }

  function reconcileAndOpen() {
    var recoveringAdd = !!addRecoveryError;
    openDrawer();
    return mutation(function () {
      return offerClient().reconcile()
        .then(refresh)
        .then(function () { addRecoveryError = null; status(''); });
    }, true).then(function () {
      if (recoveringAdd) window.dispatchEvent(new window.CustomEvent('veji-cart:recovered'));
    });
  }

  function checkout() {
    if (!renderConfirmed) return Promise.reject(new Error('Panier non confirmé. Fermez puis rouvrez le panier pour actualiser.'));
    return mutation(function () {
      return offerClient().reconcile()
        .then(refresh)
        .then(function () { window.location.assign('/checkout'); });
    });
  }

  function report(error) { status(errorMessage(error)); }

  function formItems(form) {
    var data = new FormData(form);
    var id = data.get('id');
    if (!id) throw new Error('Produit indisponible.');
    var item = { id: id, quantity: parseInt(data.get('quantity'), 10) || 1 };
    var plan = data.get('selling_plan');
    if (plan) item.selling_plan = plan;
    var properties = {};
    data.forEach(function (value, key) {
      var match = /^properties\[(.+)\]$/.exec(key);
      if (match) properties[match[1]] = value;
    });
    if (Object.keys(properties).length) item.properties = properties;
    return [item];
  }

  function canHoverInfo(event) {
    return event.pointerType === 'mouse' && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  }

  document.addEventListener('pointerover', function (event) {
    var details = event.target.closest('.veji-cd-purchase-info');
    if (!details || !canHoverInfo(event)) return;
    window.clearTimeout(details.vejiCloseTimer);
    closePurchaseInfo(details, false);
    details.open = true;
  });

  document.addEventListener('pointerout', function (event) {
    var details = event.target.closest('.veji-cd-purchase-info');
    if (!details || !canHoverInfo(event) || details.contains(event.relatedTarget)) return;
    details.vejiCloseTimer = window.setTimeout(function () { details.open = false; }, 120);
  });

  document.addEventListener('click', function (event) {
    closePurchaseInfo(event.target, false);
    var info = event.target.closest('.veji-cd-purchase-info summary');
    if (info && canHoverInfo(event)) { event.preventDefault(); info.parentElement.open = true; return; }
    var opener = event.target.closest('[data-veji-cart-open]');
    if (opener) { event.preventDefault(); reconcileAndOpen().catch(report); return; }
    if (event.target.closest('[data-veji-cart-close]') || event.target.closest('[data-veji-cart-overlay]')) {
      var emptyLink = event.target.closest('.veji-cd-empty-cta');
      if (emptyLink && emptyLink.getAttribute('href') && emptyLink.getAttribute('href') !== '#') return;
      event.preventDefault(); closeDrawer(); return;
    }
    var change = event.target.closest('[data-veji-cart-change]');
    if (change) { event.preventDefault(); changeLine(change.getAttribute('data-key'), parseInt(change.getAttribute('data-qty'), 10)).catch(report); return; }
    var remove = event.target.closest('[data-veji-cart-remove]');
    if (remove) { event.preventDefault(); changeLine(remove.getAttribute('data-key'), 0).catch(report); return; }
    var complement = event.target.closest('[data-veji-cart-cross-sell-add]');
    if (complement) {
      event.preventDefault();
      try { addComplement(complement).catch(reportComplement); } catch (error) { reportComplement(error); }
      return;
    }
    var add = event.target.closest('[data-veji-cart-add]');
    if (add) { event.preventDefault(); addItems([{ id: add.getAttribute('data-id'), quantity: 1 }]).catch(report); return; }
    if (event.target.closest('[data-veji-cart-checkout]')) { event.preventDefault(); checkout().catch(report); }
  });


  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches) return;
    var isCartPage = form.matches('[data-veji-cartpage-form]');
    var action = form.getAttribute('action') || '';
    var isAdd = form.hasAttribute('data-veji-buyform') || /\/cart\/add/.test(action);
    if (!isCartPage && !isAdd) return;
    event.preventDefault();
    if (isCartPage) { checkout().catch(report); return; }
    try { addItems(formItems(form)).catch(report); } catch (error) { report(error); }
  });

  document.addEventListener('change', function (event) {
    var control = event.target;
    if (control.matches('[data-veji-purchase-toggle]')) {
      changePurchase(control, control.checked ? 2 : null).catch(report);
    } else if (control.matches('[data-veji-purchase-cadence]')) {
      changePurchase(control, Number(control.value)).catch(report);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    if (closePurchaseInfo(null, true)) { event.preventDefault(); return; }
    closeDrawer();
  });

  function initDynamic() {
    document.querySelectorAll('[data-veji-cart-cross-sell]').forEach(function (card) {
      card.hidden = true;
    });
  }

  window.VejiCart = window.VejiCart || {};
  window.VejiCart.addItems = addItems;
  window.VejiCart.addComparisonComplement = addComparisonComplement;
  window.VejiCart.refresh = refresh;
  window.VejiCart.open = reconcileAndOpen;
  window.VejiCart.close = closeDrawer;
  function init() {
    initDynamic();
    if (pageRoot() && approvedRuntime()) mutation(function () { return offerClient().verify().then(refresh); }).catch(report);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
